import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';

import * as actionCreators from '../../../store/actions/index';

import LandingSet from '../../../libs/LandingSet';

import './Header.scss';

const Header = props => {

    useEffect(() => {   
        
        
        const langOptions = $('.Header__language--option').remove().toArray();
        
        const newlangOptions = langOptions.sort((a,b) => ($(a).text() > $(b).text()) ? 1 : -1);

        $('.Header__language').append(newlangOptions);

        $(`.${props.currentLang}`).prop('selected', 'selected');
    }, [props.currentQuestion])
    

    const langPickerHandlr = (e) => {
        props.onChangeLang(e.target.value);

        if(props.currentRole !== 'Select your functional area'){
            props.onChooseQuestions(props.currentRole, e.target.value);
            props.onChangeRole(props.currentRole, e.target.value);
        }
    };

    $('.Header__language--1').change(function(){
        var text = $(this).find('option:selected').text()        
        var $aux = $('<select/>').append($('<option/>').text(text))
        // $('#__bkframe').addClass(props.currentLang);

        $('.ochat_slideout').removeClass('English Spanish SpanishLAD French German Italian PortugueseBR Russian Turkish');
        $('.ochat_modal').removeClass('English Spanish SpanishLAD French German Italian PortugueseBR Russian Turkish');

        $('.ochat_slideout').addClass(props.currentLang);
        $('.ochat_modal').addClass(props.currentLang);

        $(this).after($aux);
        $(this).width($aux.width()+35)
        $aux.remove()
      }).change()

    return (
        <header className="Header" role='header'>
            <div className="Header__strip"></div>            
            <div className="Header__wrapper">
                <div className="Header__logo"></div>
                
                {props.currentQuestion === 0 ? 
                    (   
                        null
                    ): (
                        <a href={`http://${window.location.host}${window.location.pathname}`} className="Header__restart Header__btn">
                            <div className="Header__restart--img"></div>
                            <div className="Header__restart--txt">{LandingSet.restartBtn[props.currentLang]}</div>
                        </a>
                    ) 
                }               
            </div>            
        </header>
    )
};


const mapStateToProps = state => { 
    return {
        currentLang: state.langReducer.currentLang,
        EXISTING_LANGS: state.langReducer.EXISTING_LANGS,
        currentQuestion: state.questionsReducer.currentQuestion,
        currentRole: state.roleReducer.currentRole,
        currentQuestions: state.questionsReducer.currentQuestions,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onChangeLang: (lang) => dispatch(actionCreators.choose_lang(lang)),     
        onChooseQuestions: (role, lang) => dispatch(actionCreators.choose_questions(role, lang)),      
        onChangeRole: (role, lang) => dispatch(actionCreators.choose_role(role, lang)),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Header);